import * as angular from 'angular';
import StandardComponent from "components/standards/components/StandardComponent";
import FieldActionsController from "./controllers/field-actions.controller";

"use strict";

class FieldActionsComponent extends StandardComponent {

    // This will enable the debug mode of this class
    public debug = false;
    public moduleFolder = 'components/field-actions';

    /**
     * PLease make sure that each function contain correct
     * documentation.
     */
    public bindings = {
        action: '@',
        scanStation: '=',
        fc: '=',
        data: '=',
        main: '='
    }

    // This will set what will be the controller of this component
    public controller : any = FieldActionsController;

    // This will set an alias
    public controllerAs: string = 'fieldActions';
}

angular.module('FieldModule').component('fieldActions', <StandardComponent> new FieldActionsComponent);